import React, { Fragment, useEffect, useState } from "react";
import Constant from "../../../utils/constant";
import { IVideo, IVideoInfo } from "../../../model/interface/video";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import { Link, useNavigate, useLocation } from "react-router";
import { useForm } from "react-hook-form";
import Breadcrumb from "../../shared/common/breadcrumb";
import LinkedStandard from "../../shared/common/linkedStandard";
import Select from "react-select";
import { XIcon } from "@heroicons/react/outline";
import {
  updateVideo,
  addVideo,
  getVideo,
  postVideoTag,
  deleteVideoTag,
} from "../../../api/videos.service";
import {
  IReactSelect,
  ISelectElement,
} from "../../../model/interface/keyValuePair";
import { getAllDomainsBySubject } from "../../../api/domain.service";
import Loader from "../../shared/loader/loader";
import { getContentArea } from "../../../api/contentArea.service";
import { getSubjectAllByContent } from "../../../api/subject.service";
import { getStandardsByDomainId } from "../../../api/standard.service";
import { toast } from "react-toastify";
import constant from "../../../utils/constant";
import AssociatedQuestion from "./associatedQuestionTab";
import TagsTab from "./tagsTab";
import { getAssociatedStandards } from "../../../api/standardLinking.service";
import { IlinkedStandard } from "../../../model/interface/linkedStandard";
import VideoStandards from "./videoStandardsTab";
import ReactPlayer from "react-player";
import { connect } from "react-redux";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { AddIcon } from "../../../assets/icons";
import { uploadAsset } from "../../../api/question.service";
import { uploadThumbnail } from "../../../api/videos.service";
import {
  generateVideoThumbnails,
  generateVideoThumbnailViaUrl,
  getVideoDurationFromVideoFile,
} from "@rajesh896/video-thumbnails-generator";
import { v4 as uuid, validate as isValidUUID } from "uuid";
import { useNumericParam } from "../../../utils/useNumericParam";

function ManageVideo(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const parameters = location.state as any;
  type tabName = "Video" | "AssociatedQuestions" | "videoStandards" | "Tags";
  const [activeTab, setActiveTab] = useState<tabName>(
    parameters?.fromAssociatedPage ? "AssociatedQuestions" : "Video"
  );
  const [selectedThumbnail, setSelectedThumbnail] = useState<string>();
  const [thumbnails, setThumbnails] = useState<string[]>();

  const [lang, setLang] = useState<number>(1);
  const activeTabClass =
    "text-gray-900 topBorder bg-white border border-b-0 group relative min-w-0 flex-1 mb-0 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 dark:hover:bg-gray-700 focus:z-10";
  const inActiveTabClass =
    "text-gray-500 hover:text-gray-700 group relative min-w-0 flex-1 overflow-hidden mb-0 py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10";

  const defaultData: IVideo = {
    videoId: 0,
    standardId: 0,
    transcript: "",
    spanishTranscript: "",
    videoUrl: "",
    spanishVideoUrl: "",
    englishVttUrl: "",
    spanishVttUrl: "",
    standardName: "",
    standardCode: "",
    title: "",
    spanishTitle: "",
    userId: 0,
    contentAreaId: 0,
    subjectId: 0,
    domainId: 0,
    isApproved: true,
    isActive: true,
    englishVideoReferenceId: "",
    spanishVideoReferenceId: "",
    videoTags: [],
    gradeLevelId: "",
    gradeLevel: "",
  };
  const id = useNumericParam("id");
  const idToEdit = id ? id : 0;
  const [video, setVideo] = useState<IVideo>(defaultData);
  const [videoToEdit, setVideoToEdit] = useState<IVideo>();
  const [selectedStandard, setSelectedStandard] = useState<IReactSelect>({
    label: parameters?.objectToEdit?.standardName || "",
    value: parameters?.objectToEdit?.standardId || "",
  });
  const [selectedContent, setSelectedContent] = useState<ISelectElement>({
    label: parameters?.objectToEdit?.contentAreaName || "",
    value: parameters?.objectToEdit?.contentAreaId || "",
  });
  const [selectedSubject, setSelectedSubject] = useState<ISelectElement>({
    label: parameters?.objectToEdit?.subjectName || "",
    value: parameters?.objectToEdit?.subjectId || "",
  });
  const [selectedDomain, setSelectedDomain] = useState<ISelectElement>({
    label: parameters?.objectToEdit?.domainName || "",
    value: parameters?.objectToEdit?.domainId || "",
  });
  const [externalId, setExternalId] = useState<string>();
  const [domains, setDomains] = useState<ISelectElement[]>([]);
  const [contentAreas, setContentAreas] = useState<ISelectElement[]>([]);
  const [subjects, setSubjects] = useState<ISelectElement[]>([]);
  const [standards, setStandards] = useState<ISelectElement[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [showLinkedStandards, setShowLinkedStandards] =
    useState<boolean>(false);
  const [showLearnosityVideoEditor, setShowLearnosityVideoEditor] =
    useState<boolean>(false);
  const [showVttEditor, setShowVttEditor] = useState<boolean>(false);
  const [linkedStandards, setLinkedStandards] = useState<IlinkedStandard[]>([]);
  const [associateQuestionIds, setAssociateQuestionIds] = useState<string[]>(
    []
  );
  const [selectedTagIds, setSelectedTagIds] = useState<Array<number>>([]);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  // IMPORTANT:
  // This component is used for both "Add" and "Edit" routes.
  // Navigating from Add -> Edit (after initial Save) often does NOT remount the component,
  // so we must re-run the bind logic whenever the route param changes.
  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      setLoading(true);
      try {
        // If we navigated here with state (e.g. from Standard), seed initial values.
        if (parameters?.objectToEdit && idToEdit === 0) {
          setVideoToEdit(parameters.objectToEdit);
          setVideo(parameters.objectToEdit);
        } else {
          // When switching routes (Add -> Edit), clear stale "new" state while we fetch.
          setVideoToEdit(undefined);
        }

        await bindVideoToEdit();
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [idToEdit, location.pathname]);

  const bindVideoTags = (tags) => {
    if (tags && tags.length > 0) {
      const tagIds = tags.map((tag) => tag.tagId);
      setSelectedTagIds(tagIds);
    }
  };

  async function bindVideoToEdit() {
    if (idToEdit) {
      try {
        const response = await getVideo(idToEdit);
        const videoEditData: IVideo = response?.data;
        if (!videoEditData) return;

        setVideoToEdit(videoEditData);
        setVideo(videoEditData);
        reset({
          title: videoEditData.title,
          spanishTitle: videoEditData.spanishTitle,
          VideoUrl: videoEditData.videoUrl,
          SpanishVideoUrl: videoEditData.spanishVideoUrl,
          EnglishVttUrl: videoEditData.englishVttUrl,
          SpanishVttUrl: videoEditData.spanishVttUrl,
          transcript: videoEditData.transcript,
          spanishTranscript: videoEditData.spanishTranscript,
        });

        const selectedContent: any = videoEditData
          ? {
              label: videoEditData.contentAreaName,
              value: videoEditData.contentAreaId,
            }
          : undefined;

        const selectedSubject: any = videoEditData
          ? {
              label: videoEditData.subjectName,
              value: videoEditData.subjectId,
            }
          : undefined;

        const selectedDomain: any = videoEditData
          ? {
              label: videoEditData.domainName,
              value: videoEditData.domainId,
            }
          : undefined;
        const selectedStandard: any = videoEditData
          ? {
              label: videoEditData.standardName,
              value: videoEditData.standardId,
            }
          : undefined;
        await bindContentAreas(selectedContent);
        await bindSubjects(selectedContent, selectedSubject.value);
        bindDomains(selectedSubject, selectedDomain.value);
        bindStandards(selectedDomain, selectedStandard.value);
        bindVideoTags(videoEditData.videoTags);
        setSelectedThumbnail(videoEditData.thumbnail);
        setThumbnails(videoEditData.thumbnails);
        setExternalId(videoEditData.externalId ?? undefined);
      } catch (e) {
        console.log(e);
      }
    } else {
      await bindContentAreas();
      await bindSubjects();
      bindDomains();
      bindStandards();
    }
  }

  const getYTThumbnails = (videoUrl: string | undefined) => {
    let ytId: string | undefined;
    if (videoUrl?.includes("youtube.com")) {
      ytId = videoUrl?.split("v=")[1]?.split("&")[0];
    } else if (videoUrl?.includes("youtu.be")) {
      ytId = videoUrl?.split("/").pop();
      if (ytId?.includes("?")) {
        ytId = ytId.split("?")[0];
      }
    }

    if (ytId) {
      const thumbnails: string[] = [
        "https://img.youtube.com/vi/" + ytId + "/0.jpg",
        "https://img.youtube.com/vi/" + ytId + "/1.jpg",
        "https://img.youtube.com/vi/" + ytId + "/2.jpg",
        "https://img.youtube.com/vi/" + ytId + "/3.jpg",
      ];
      return thumbnails;
    }
    return [];
  };

  useEffect(() => {
    if (videoToEdit && videoToEdit.videoId > 0 && videoToEdit.thumbnail) {
      setTimeout(function () {
        setVideoThumbnail(video.thumbnail);
      }, 2000);
    } else if (
      videoToEdit &&
      videoToEdit.videoId > 0 &&
      videoToEdit.videoUrl &&
      !videoToEdit.thumbnail &&
      videoToEdit.thumbnails?.length === 0
    ) {
      GenerateVideoThumbnailsViaUrl(
        videoToEdit.videoUrl,
        videoToEdit.externalId
      );
    }
  }, [videoToEdit]);

  async function onSubmit(data: any) {
    if (isSaving) return;
    setLoading(true);
    try {
      setIsSaving(true);
      let successMessage: string;
      const videoArr: IVideoInfo[] = [];
      const spanishVideoExists =
        video.spanishVideoUrl !== "" && video.spanishVideoUrl !== null;
      const isYouTube = isYouTubeVideo(video.videoUrl);
      videoArr.push(
        {
          type: "videoplayer",
          reference:
            videoToEdit && videoToEdit.englishVideoReferenceId
              ? videoToEdit.englishVideoReferenceId
              : "en",
          data: {
            type: "videoplayer",
            metadata: {
              transcript: video.transcript,
            },
            playerType: video.videoUrl.includes("vimeo")
              ? "vimeo"
              : video.videoUrl.includes("iframe")
              ? "brightcove"
              : isYouTube
              ? "youtube"
              : "hosted-video",
            heading: video.title,
            src: !video.videoUrl.includes("iframe")
              ? video.videoUrl
              : undefined,
            brightcoveCode: video.videoUrl.includes("iframe")
              ? '<iframe src="' + video.videoUrl + '"></iframe>'
              : undefined,
          },
        },
        {
          type: "videoplayer",
          reference:
            videoToEdit && videoToEdit.spanishVideoReferenceId
              ? videoToEdit.spanishVideoReferenceId
              : "es",
          data: {
            type: "videoplayer",
            metadata: {
              transcript:
                video.spanishTranscript !== ""
                  ? video.spanishTranscript
                  : video.transcript,
            },
            playerType:
              (spanishVideoExists && video.spanishVideoUrl.includes("vimeo")) ||
              video.videoUrl.includes("vimeo")
                ? "vimeo"
                : (spanishVideoExists &&
                    video.spanishVideoUrl.includes("iframe")) ||
                  video.videoUrl.includes("iframe")
                ? "brightcove"
                : isYouTube
                ? "youtube"
                : "hosted-video",
            heading:
              video.spanishTitle !== "" ? video.spanishTitle : video.title,
            src:
              spanishVideoExists && !video.spanishVideoUrl.includes("iframe")
                ? video.spanishVideoUrl
                : !video.videoUrl.includes("iframe")
                ? video.videoUrl
                : undefined,
            brightcoveCode:
              spanishVideoExists && video.spanishVideoUrl.includes("iframe")
                ? '<iframe src="' + video.spanishVideoUrl + '"></iframe>'
                : video.videoUrl.includes("iframe")
                ? '<iframe src="' + video.videoUrl + '"></iframe>'
                : undefined,
          },
        }
      );
      const videoData = {
        // Use route param as source of truth; prevents duplicate records if state is stale.
        videoId: idToEdit && idToEdit > 0 ? idToEdit : 0,
        transcript: video.transcript,
        spanishTranscript:
          video.spanishTranscript !== ""
            ? video.spanishTranscript
            : video.transcript,
        videoUrl: video.videoUrl,
        spanishVideoUrl:
          video.spanishVideoUrl !== "" ? video.spanishVideoUrl : video.videoUrl,
        title: video.title,
        spanishTitle:
          video.spanishTitle !== "" ? video.spanishTitle : video.title,
        isApproved:
          videoToEdit && videoToEdit.isApproved ? videoToEdit.isApproved : true,
        userId: props.profile?.userId,
        standardId: selectedStandard?.value,
        videos: videoArr,
        englishVideoReferenceId:
          videoToEdit && videoToEdit.englishVideoReferenceId
            ? videoToEdit.englishVideoReferenceId
            : "",
        spanishVideoReferenceId:
          videoToEdit && videoToEdit.spanishVideoReferenceId
            ? videoToEdit.spanishVideoReferenceId
            : "",
        questionRefIds: associateQuestionIds,
        isActive: true,
        thumbnail: selectedThumbnail,
        thumbnails:
          thumbnails?.length ?? 0 > 0
            ? thumbnails
            : isYouTube
            ? getYTThumbnails(videoToEdit?.videoUrl)
            : undefined,
        lengthInSeconds: isYouTube ? 0 : await GetVideoDuration(video.videoUrl),
        externalId: externalId ?? GetExternalId(video.videoUrl),
        englishVttUrl: video.englishVttUrl,
        spanishVttUrl: video.spanishVttUrl,
      };
      if (idToEdit && idToEdit > 0) {
        await updateVideo(videoData);
        navigate(constant.VIDEOEDIT.replace(":id", idToEdit.toString()));
        successMessage = "Video saved successfully";
      } else {
        const result = await addVideo(videoData);
        const newIdRaw: any =
          (result as any)?.data?.data ?? (result as any)?.data;
        const newId =
          typeof newIdRaw === "string" ? parseInt(newIdRaw, 10) : newIdRaw;
        navigate(
          constant.VIDEOEDIT.replace(
            ":id",
            newId?.toString?.() ?? newIdRaw?.toString?.() ?? ""
          )
        );
        successMessage = "Video saved successfully";
      }
      setLoading(false);
      toast.success(successMessage);
      setIsSaving(false);
    } catch (error) {
      toast.error("Failed to save video");
    } finally {
      setLoading(false);
      setIsSaving(false);
    }
  }

  function handleShowLinkedStandardsConfirmation(standardId: number) {
    getAssociatedStandards(standardId).then((response) => {
      if (response && response.data.length > 0) {
        setShowLinkedStandards(true);
        setLinkedStandards(response.data);
      } else handleRedirect();
    });
  }
  function handleRedirection(name: string, id: number) {
    if (name && id) {
      navigate(`/${name}/edit/${id}`);
    } else {
      navigate(`/${name}`);
    }
  }
  const handleRedirect = () => {
    navigate(
      videoToEdit?.videoId
        ? Constant.VIDEOS
        : videoToEdit?.standardId
        ? Constant.EDITSTANDARD.replace(
            ":id",
            videoToEdit?.standardId.toString()
          )
        : Constant.VIDEOS,
      { state: { fromVideoPage: true } }
    );
  };
  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Video", url: Constant.VIDEOS },
      { name: idToEdit ? "Edit Video" : "Add Video", url: "" },
    ];

    if (idToEdit) {
      items.push({
        name: "",
        url: "",
        objectId: idToEdit
          ? idToEdit.toString()
          : videoToEdit?.videoId.toString(),
      });
    }
    return items;
  };

  function handleContentAreaChange(selectedItem: any) {
    setSelectedContent(selectedItem);
    bindSubjects(selectedItem);
  }

  function handleSubjectChange(selectedItem: any) {
    setSelectedSubject(selectedItem);
    bindDomains(selectedItem);
  }
  function handleDomainChange(selectedItem: any) {
    setSelectedDomain(selectedItem);
    bindStandards(selectedItem);
  }
  function handleStandardChange(selectedItem: any) {
    setSelectedStandard(selectedItem);
    if (selectedItem.value) {
      setVideo({
        ...video,
        standardId: parseInt(selectedItem.value) || 0,
      });
    }
  }
  async function bindContentAreas(selectedItem?: ISelectElement) {
    setLoading(true);
    const response = await getContentArea();
    const result = response.data.data;
    const contentAreaData = result.map((item) => {
      return { label: item.name, value: item.contentAreaId };
    });
    setContentAreas(contentAreaData);
    if (selectedItem) {
      setSelectedContent(selectedItem);
    } else if (videoToEdit && videoToEdit.contentAreaId > 0) {
      const selectedContentArea = contentAreaData.find((t) => {
        return t.value === videoToEdit.contentAreaId;
      });
      setSelectedContent(selectedContentArea);
    }
    setLoading(false);
  }
  async function bindSubjects(
    selectedItem?: ISelectElement,
    subjectId?: number
  ) {
    setLoading(true);
    const contentId =
      selectedItem?.value == undefined
        ? videoToEdit && videoToEdit.contentAreaId
        : parseInt(selectedItem.value);
    const response = await getSubjectAllByContent(contentId);
    const result = response.data;
    const subjectsData = result.map((item) => {
      return { label: item.subjectName, value: item.subjectId };
    });

    setSubjects(subjectsData);
    const currentSubject = videoToEdit ? videoToEdit.subjectId : subjectId;
    if (currentSubject) {
      const selectedSubject = subjectsData.find((t) => {
        return t.value === currentSubject;
      });
      setSelectedSubject(selectedSubject);
    }
    setLoading(false);
  }
  function bindDomains(selectedItem?: ISelectElement, domainId?: number) {
    const subjectId =
      selectedItem?.value == undefined
        ? videoToEdit && videoToEdit.subjectId
        : parseInt(selectedItem.value);
    getAllDomainsBySubject(subjectId).then((response) => {
      setLoading(true);

      const result = response.data.data;
      const domainsData = result.map((item) => {
        return { label: item.name, value: item.domainId };
      });
      setDomains(domainsData);
      const currentDomain = videoToEdit
        ? videoToEdit.domainId
          ? videoToEdit.domainId
          : 0
        : domainId;
      if (currentDomain) {
        const selectedDomain = domainsData.find((t) => {
          return t.value === currentDomain;
        });
        setSelectedDomain(selectedDomain);
      }
      setLoading(false);
    });
  }
  function bindStandards(selectedItem?: ISelectElement, standardId?: number) {
    const domainId =
      selectedItem?.value == undefined
        ? videoToEdit && videoToEdit.domainId
        : parseInt(selectedItem.value);

    if (domainId)
      getStandardsByDomainId(domainId).then((response: any) => {
        setLoading(true);
        if (response.data.data.length > 0) {
          const standards = response.data.data.map((standard) => {
            return {
              label: standard.code + " " + standard.name,
              value: standard.standardId,
            };
          });
          setStandards(standards);

          const currentStandard =
            selectedItem?.value == undefined
              ? videoToEdit && videoToEdit.standardId
              : standardId;

          if (currentStandard) {
            const selectedStandard = standards.find((t) => {
              return t.value === currentStandard;
            });
            if (selectedStandard) {
              setSelectedStandard(selectedStandard);
            }
          }
          setLoading(false);
        }
      });
  }
  function validateUrl(value) {
    const validationUrl = new RegExp(Constant.URL_VALIDATOR_EXPRESSION);
    return validationUrl.test(value);
  }

  /** Code to check whether video with player or not. This should be removed after we move from wistia to another platform */
  const checkVideoWithPlayer = (value) => {
    if (value.includes("wistia")) return true;
    return false;
  };

  function handleFilterChange(e: any, type) {
    let thumbs: string[] = [];
    switch (type) {
      case "VideoUrl":
        if (isYouTubeVideo(e.target.value)) {
          thumbs = getYTThumbnails(e.target.value);
          setThumbnails(thumbs);
        }
        setVideo({
          ...video,
          videoUrl: e.target.value || "",
          thumbnails: thumbs,
        });
        setValue("VideoUrl", e.target.value || "", { shouldValidate: true });
        break;
      case "SpanishVideoUrl":
        setVideo({
          ...video,
          spanishVideoUrl: e.target.value || "",
        });
        setValue("SpanishVideoUrl", e.target.value || "");
        break;
      case "EnglishVttUrl":
        setVideo({
          ...video,
          englishVttUrl: e.target.value || "",
        });
        setValue("EnglishVttUrl", e.target.value || "");
        break;
      case "SpanishVttUrl":
        setVideo({
          ...video,
          spanishVttUrl: e.target.value || "",
        });
        setValue("SpanishVttUrl", e.target.value || "");
        break;
      case "Transcript":
        setVideo({
          ...video,
          transcript: e.target.value || "",
        });
        setValue("transcript", e.target.value || "");
        break;
      case "SpanishTranscript":
        setVideo({
          ...video,
          spanishTranscript: e.target.value || "",
        });
        setValue("spanishTranscript", e.target.value || "");
        break;
      case "StandardId":
        setVideo({
          ...video,
          standardId: e.target.value || "",
        });
        break;
      case "Title":
        if (lang == Constant.ENGLISH) {
          setVideo({
            ...video,
            title: e.target.value || "",
          });
          setValue("title", e.target.value || "", { shouldValidate: true });
        } else {
          setVideo({
            ...video,
            spanishTitle: e.target.value || "",
          });
          setValue("spanishTitle", e.target.value || "");
        }
        break;
      case "IsActive":
        setVideo({
          ...video,
          isActive: e || true,
        });
        break;
    }
  }

  function getVideoURL(url: string) {
    if (url && url.indexOf("vimeo") > 0) {
      const id = url.match(/[0-9]+/);
      const vimeoId = id ? id[0] : 0;
      const vimeoURL =
        "https://player.vimeo.com/video/" + vimeoId + "?background=1";
      return vimeoURL;
    } else if (url?.indexOf("youtu.be") > 0) {
      // Support for YouTube URLs
      const id = url.split("/").pop();
      const youtubeURL =
        "https://www.youtube.com/embed/" +
        id +
        "?autoplay=1&origin=" +
        window.location.origin;
      return youtubeURL;
    } else {
      return url;
    }
  }
  const transcriptFormater = (text: string) => {
    return text?.replace(/(?:\r\n|\r|\n)/g, "<br>");
  };

  const toggleLang = () => {
    if (lang === 1) {
      setLang(2);
    } else {
      setLang(1);
    }
  };

  const handleSaveTags = (tags) => {
    const selectedTagIds = tags
      .filter((tag) => tag.selected === true)
      .map((tag) => tag.tagId);

    const tag = {
      videoId: Number(id),
      tagId: selectedTagIds,
    };
    setSelectedTagIds(selectedTagIds);
    postVideoTag(tag);
  };

  const handleRemoveTag = (allTags, tag) => {
    const selectedTagIds = allTags
      .filter((t) => t.selected === true)
      .map((t) => t.tagId);

    const tagParam = {
      videoId: Number(id),
      tagId: tag.tagId,
    };
    setSelectedTagIds(selectedTagIds);
    deleteVideoTag(tagParam);
  };

  const onVideoUpload = async (e) => {
    setLoading(true);
    if (e.target.files[0]) {
      const formData = new FormData();
      setSelectedThumbnail("");
      setThumbnails([]);
      formData.append("file", e.target.files[0]);
      formData.append("type", "video");
      await uploadAsset(formData).then((res) => {
        if (res.data && res.data.success) {
          saveVideoUrl(res.data.data);
          GenerateVideoThumbnails(e.target.files[0], res.data.data);
        }
        setLoading(false);
      });
    }
  };

  const onVttUpload = async (e) => {
    setLoading(true);
    if (e.target.files[0]) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("type", "videoVtt");
      const suffix = lang === 1 ? "" : "-es";
      formData.append("suffix", suffix);
      await uploadAsset(formData).then((res) => {
        if (res.data && res.data.success) {
          saveVttUrl(res.data.data);
        }
        setLoading(false);
      });
    }
  };

  const GetExternalId = (videoUrl) => {
    let externalId;
    const videoUrlArray = videoUrl.split("/");
    if (videoUrl.includes("explanation")) {
      externalId = videoUrlArray[videoUrlArray.length - 1].includes(".")
        ? videoUrlArray[videoUrlArray.length - 1].split(".")[0]
        : videoUrlArray[videoUrlArray.length - 1];
    } else if (videoUrl.includes("video.mp4")) {
      externalId = videoUrlArray[videoUrlArray.length - 2];
    } else {
      externalId = videoUrlArray[videoUrlArray.length - 1].includes(".")
        ? videoUrlArray[videoUrlArray.length - 1].split(".")[0]
        : videoUrlArray[videoUrlArray.length - 1];
    }
    if (isValidGuid(externalId)) {
      return externalId;
    } else {
      externalId = uuid();
      return externalId;
    }
  };
  const GenerateVideoThumbnails = (file, videoUrl) => {
    generateVideoThumbnails(file, 4, "file").then((thumbs) => {
      const videoExternalId = GetExternalId(videoUrl);
      setExternalId(videoExternalId);
      const request = {
        videothumbnailFiles: thumbs,
        type: "thumbnail",
        videoExternalId: videoExternalId,
      };
      UploadThumbnail(request);
    });
  };

  const isYouTubeVideo = (videoUrl) => {
    return (
      videoUrl?.indexOf("youtu.be") > 0 || videoUrl?.indexOf("youtube.com") > 0
    );
  };

  const GetVideoDuration = async (videoUrl) => {
    let duration = 0;
    try {
      duration = await getVideoDurationFromVideoFile(videoUrl).catch(
        (error) => {
          console.log(error);
          return 0;
        }
      );
    } catch (e) {
      console.log(e);
      const videos = document.getElementsByTagName("video");
      if (videos && videos.length > 0) {
        duration = videos[0]?.duration;
      }
    }
    return Math.floor(duration);
  };
  const GenerateVideoThumbnailsViaUrl = async (videoUrl, externalId) => {
    const noOfThumbnails = 4;
    const duration = await GetVideoDuration(videoUrl);
    const fractions: number[] = [];
    const thumbnail: string[] = [];
    if (duration > 0) {
      for (let i = 0; i <= duration; i += duration / noOfThumbnails) {
        fractions.push(Math.floor(i));
      }
    } else {
      fractions.push(0);
    }

    //the array of promises
    let index = 0;
    const promiseArray = fractions.map((time, i) => {
      generateVideoThumbnailViaUrl(videoUrl, time)
        .then((res) => {
          thumbnail?.push(res);
          index++;
          if (index === fractions.length) {
            const videoExternalId = externalId ?? GetExternalId(videoUrl);
            setExternalId(videoExternalId);
            const request = {
              videothumbnailFiles: thumbnail,
              type: "thumbnail",
              videoExternalId: videoExternalId,
            };
            UploadThumbnail(request);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    });
  };
  const UploadThumbnail = (request) => {
    setLoading(true);
    try {
      uploadThumbnail(request)
        .then((response) => {
          setLoading(false);
          if (response && response.data) {
            setLoading(false);
            setThumbnails(response.data);
            setSelectedThumbnail(response.data[0]);
          }
        })
        .catch(function (error) {
          setLoading(false);
        });
    } catch (e) {
      setLoading(false);
    }
  };
  const setVideoThumbnail = (image) => {
    setSelectedThumbnail(image);
    const video = document.getElementsByTagName("video");
    if (video != null && video.length > 0) {
      video[0].setAttribute("poster", image);
    }
  };
  const saveVideoUrl = (videoUrl) => {
    if (lang == 1) {
      setVideo({
        ...video,
        videoUrl: videoUrl || "",
      });
      setValue("VideoUrl", videoUrl || "", { shouldValidate: true });
    } else {
      setVideo({
        ...video,
        spanishVideoUrl: videoUrl || "",
      });
      setValue("SpanishVideoUrl", videoUrl || "");
    }
    setShowLearnosityVideoEditor(false);
  };
  const saveVttUrl = (vttUrl) => {
    if (lang == 1) {
      setVideo({
        ...video,
        englishVttUrl: vttUrl || "",
      });
      setValue("EnglishVttUrl", vttUrl || "");
    } else {
      setVideo({
        ...video,
        spanishVttUrl: vttUrl || "",
      });
      setValue("SpanishVttUrl", vttUrl || "");
    }
    setShowVttEditor(false);
  };
  const isValidGuid = (str) => {
    const isValid = isValidUUID(str);
    return isValid;
  };

  return (
    <AllowedTo
      perform={[Permissions.video_create, Permissions.video_modify]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}
      {showLearnosityVideoEditor && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>

            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div className="inline-block w-full align-bottom bg-white px-4 pt-5 pb-8 text-left  shadow-xl transform transition-all sm:align-middle max-w-sm sm:p-6">
              <div className=" flex justify-end">
                <button
                  onClick={() => setShowLearnosityVideoEditor(false)}
                  type="button"
                  className="bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                >
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div className="grid grid-cols-1 mt-5">
                <div className="text-sm flex items-center">
                  <label className="font-medium text-base text-gray-700">
                    Upload Video
                  </label>
                </div>
                <div className="flex items-center">
                  <input
                    type="file"
                    accept="video/*"
                    onChange={onVideoUpload}
                    name="videoFile"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showVttEditor && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>

            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div className="inline-block w-full align-bottom bg-white px-4 pt-5 pb-8 text-left  shadow-xl transform transition-all sm:align-middle max-w-sm sm:p-6">
              <div className=" flex justify-end">
                <button
                  onClick={() => setShowVttEditor(false)}
                  type="button"
                  className="bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                >
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div className="grid grid-cols-1 mt-5">
                <div className="text-sm flex items-center">
                  <label className="font-medium text-base text-gray-700">
                    Upload Web VTT
                  </label>
                </div>
                <div className="flex items-center">
                  <input
                    type="file"
                    accept="text/vtt"
                    onChange={onVttUpload}
                    name="vttFile"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 overflow-y-auto mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                {videoToEdit?.videoId ? "Edit Video " : "Add Video "}
              </h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />
            <div className="mt-6 w-full">
              <div>
                <div>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex space-x-8">
                      <div className="shadow border rounded-lg border-gray-300 rounded-md mt-4 px-4 py-6 w-1/4">
                        <div className="flex justify-end">
                          <div
                            className="inline-block border text-sm border-gray-300 overflow-hidden rounded-md mb-4"
                            onClick={() => toggleLang()}
                          >
                            <span
                              className={`${
                                lang === 1
                                  ? "bg-primary-color text-white"
                                  : "bg-white text-gray-400"
                              } inline-block dark:text-white w-20 py-0.5 text-center cursor-pointer hover:opacity-80`}
                            >
                              English
                            </span>
                            <span
                              className={`${
                                lang === 2
                                  ? "bg-primary-color text-white"
                                  : "bg-white text-gray-400"
                              } w-20 py-0.5 inline-block text-center  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                            >
                              Spanish
                            </span>
                          </div>
                        </div>
                        <div>
                          <div className="grid grid-cols-1 mt-5">
                            <div className="text-sm">
                              <label className="font-medium text-gray-700">
                                Title
                              </label>
                            </div>
                            <div>
                              <input
                                id="title"
                                type="text"
                                defaultValue={videoToEdit?.title}
                                autoComplete="off"
                                className={`${
                                  lang === 1 ? "" : "hidden"
                                } mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"`}
                                {...register("title", {
                                  required: true,
                                  value:
                                    video?.title !== null && video?.title !== ""
                                      ? video?.title
                                      : videoToEdit?.title,
                                })}
                                onChange={(e) => handleFilterChange(e, "Title")}
                              />
                              <input
                                id="spanishTitle"
                                type="text"
                                defaultValue={videoToEdit?.spanishTitle}
                                autoComplete="off"
                                className={`${
                                  lang === 2 ? "" : "hidden"
                                } mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"`}
                                {...register("spanishTitle", {
                                  value:
                                    video?.spanishTitle !== null &&
                                    video?.spanishTitle !== ""
                                      ? video?.spanishTitle
                                      : videoToEdit?.spanishTitle,
                                })}
                                onChange={(e) => handleFilterChange(e, "Title")}
                              />
                              {errors.title && (
                                <span className="text-red-700 inline-block pt-1 text-sm">
                                  Title is required.
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="grid grid-cols-1 mt-5">
                            <div className="text-sm col-span-1 flex items-center ">
                              {selectedContent?.value ? (
                                <a
                                  className="text-gray-700 text-sm underline"
                                  onClick={() =>
                                    handleRedirection(
                                      "content-areas",
                                      parseInt(selectedContent?.value)
                                    )
                                  }
                                  href={`/content-areas/edit/${parseInt(
                                    selectedContent?.value
                                  )}`}
                                >
                                  Content Area
                                </a>
                              ) : (
                                <button className="text-gray-700 text-sm cursor-default">
                                  Content Area
                                </button>
                              )}
                            </div>
                            <div className="mt-1">
                              <Select
                                value={selectedContent}
                                onChange={handleContentAreaChange}
                                options={contentAreas}
                                className="text-gray-900 cursor-default select-none relative py-2"
                                isSearchable={true}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary25: "#B3B3B3",
                                    primary: "#041E42",
                                  },
                                })}
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    background:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#1A1C23"
                                        : "white",
                                    borderColor:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6B7280"
                                        : "#D1D5DB",
                                    borderWidth: "1px",
                                    "&:hover": {
                                      borderColor:
                                        state.isFocused &&
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "#6b7280"
                                          : state.isFocused
                                          ? "#4c5563"
                                          : "",
                                    },
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    color:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "white"
                                        : "#374051",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    color:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "white"
                                        : "",
                                  }),
                                }}
                              />
                            </div>
                          </div>

                          <div className="grid grid-cols-1 mt-5">
                            <div className="text-sm col-span-1 flex items-center ">
                              {selectedSubject?.value ? (
                                <a
                                  className="text-gray-700 text-sm underline"
                                  onClick={() =>
                                    handleRedirection(
                                      "subject",
                                      parseInt(selectedSubject?.value)
                                    )
                                  }
                                  href={`/subjects/edit/${parseInt(
                                    selectedSubject?.value
                                  )}`}
                                >
                                  Subject
                                </a>
                              ) : (
                                <button className="text-gray-700 text-sm cursor-default">
                                  Subject
                                </button>
                              )}
                            </div>
                            <div className="mt-1">
                              <Select
                                value={selectedSubject}
                                onChange={handleSubjectChange}
                                options={subjects}
                                className="text-gray-900 cursor-default select-none relative py-2"
                                isSearchable={true}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary25: "#B3B3B3",
                                    primary: "#041E42",
                                  },
                                })}
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    background:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#1A1C23"
                                        : "white",
                                    borderColor:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6B7280"
                                        : "#D1D5DB",
                                    borderWidth: "1px",
                                    "&:hover": {
                                      borderColor:
                                        state.isFocused &&
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "#6b7280"
                                          : state.isFocused
                                          ? "#4c5563"
                                          : "",
                                    },
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    color:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "white"
                                        : "#374051",
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    color:
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "white"
                                        : "",
                                  }),
                                }}
                              />
                            </div>
                          </div>

                          <div className="grid grid-cols-1 mt-5">
                            <div className="text-sm col-span-1flex items-center ">
                              <a
                                className="text-gray-700 text-sm underline"
                                onClick={() =>
                                  handleRedirection(
                                    "domains",
                                    parseInt(selectedDomain?.value)
                                  )
                                }
                                href={`/domains/edit/${parseInt(
                                  selectedDomain?.value
                                )}`}
                              >
                                Domain
                              </a>
                            </div>
                            <div className="mt-1">
                              <Select
                                value={selectedDomain}
                                onChange={handleDomainChange}
                                options={domains}
                                className="text-gray-900 cursor-default select-none relative py-2"
                                isSearchable={true}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary25: "#B3B3B3",
                                    primary: "#041E42",
                                  },
                                })}
                              />
                            </div>
                          </div>
                          <div className="grid grid-cols-1 mt-5">
                            <div className="text-sm col-span-1 flex items-center ">
                              {selectedStandard?.value ? (
                                <a
                                  className="text-gray-700 text-sm underline"
                                  onClick={() =>
                                    handleRedirection(
                                      "standard",
                                      parseInt(
                                        selectedStandard?.value.toString()
                                      )
                                    )
                                  }
                                  href={`/standards/edit/${parseInt(
                                    selectedStandard?.value.toString()
                                  )}`}
                                >
                                  Standard
                                </a>
                              ) : (
                                <button className="text-gray-700 text-sm cursor-default">
                                  Standard
                                </button>
                              )}
                            </div>
                            <div className="mt-1">
                              <Select
                                value={selectedStandard}
                                onChange={handleStandardChange}
                                options={standards?.map((standard) => ({
                                  value: Number.parseInt(standard.value),
                                  label: standard.label,
                                }))}
                                className="text-gray-900 cursor-default select-none relative py-2"
                                isSearchable={true}
                                theme={(theme) => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    primary25: "#B3B3B3",
                                    primary: "#041E42",
                                  },
                                })}
                              />
                            </div>
                          </div>
                          <div className="grid grid-cols-1 mt-5">
                            <div className="text-sm">
                              <label className="font-medium text-gray-700">
                                Video Url
                              </label>
                            </div>
                            <div className="flex items-center gap-x-2">
                              <input
                                id="videoUrl"
                                type="text"
                                autoComplete="off"
                                defaultValue={videoToEdit?.videoUrl}
                                value={video.videoUrl}
                                className={`${
                                  lang === 1 ? "" : "hidden"
                                } mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                                {...register("VideoUrl", {
                                  required: true,
                                  value:
                                    video?.videoUrl !== null &&
                                    video?.videoUrl !== ""
                                      ? video?.videoUrl
                                      : videoToEdit?.videoUrl,
                                })}
                                onChange={(e) =>
                                  handleFilterChange(e, "VideoUrl")
                                }
                              />
                              <input
                                id="spanishVideoUrl"
                                type="text"
                                autoComplete="off"
                                defaultValue={videoToEdit?.spanishVideoUrl}
                                value={video.spanishVideoUrl}
                                className={`${
                                  lang === 2 ? "" : "hidden"
                                } mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                                {...register("SpanishVideoUrl", {
                                  value:
                                    video?.spanishVideoUrl !== null &&
                                    video?.spanishVideoUrl !== ""
                                      ? video?.spanishVideoUrl
                                      : videoToEdit?.spanishVideoUrl,
                                })}
                                onChange={(e) =>
                                  handleFilterChange(e, "SpanishVideoUrl")
                                }
                              />
                              <span className="w-5 h-5 bg-[#1877b1] flex items-center justify-center">
                                <AddIcon
                                  className="text-white"
                                  onClick={() =>
                                    setShowLearnosityVideoEditor(true)
                                  }
                                ></AddIcon>
                              </span>
                              {errors.VideoUrl && (
                                <span className="text-red-700 inline-block pt-1 text-sm">
                                  VideoUrl is required.
                                </span>
                              )}
                            </div>
                          </div>

                          {idToEdit && idToEdit > 0 && (
                            <div className="grid grid-cols-1 mt-5">
                              <div className="text-sm">
                                <label className="font-medium text-gray-700">
                                  VTT Captions Url
                                </label>
                              </div>
                              <div className="flex items-center gap-x-2">
                                <input
                                  id="vttUrl"
                                  type="text"
                                  autoComplete="off"
                                  defaultValue={videoToEdit?.englishVttUrl}
                                  value={video.englishVttUrl}
                                  className={`${
                                    lang === 1 ? "" : "hidden"
                                  } mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                                  {...register("EnglishVttUrl", {
                                    required: false,
                                    value: video?.englishVttUrl
                                      ? video?.englishVttUrl
                                      : videoToEdit?.englishVttUrl,
                                  })}
                                  onChange={(e) =>
                                    handleFilterChange(e, "EnglishVttUrl")
                                  }
                                />
                                <input
                                  id="spanishVttUrl"
                                  type="text"
                                  autoComplete="off"
                                  defaultValue={videoToEdit?.spanishVttUrl}
                                  value={video.spanishVttUrl}
                                  className={`${
                                    lang === 2 ? "" : "hidden"
                                  } mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                                  {...register("SpanishVttUrl")}
                                  onChange={(e) =>
                                    handleFilterChange(e, "SpanishVttUrl")
                                  }
                                />
                                <span className="w-5 h-5 bg-[#1877b1] flex items-center justify-center">
                                  <AddIcon
                                    className="text-white"
                                    onClick={() => setShowVttEditor(true)}
                                  ></AddIcon>
                                </span>
                              </div>
                            </div>
                          )}

                          <div className="grid grid-cols-1 mt-5">
                            <div className="text-sm">
                              <label className="font-medium text-gray-700">
                                {" "}
                                Transcript
                              </label>
                            </div>
                            <div>
                              <textarea
                                id="transcript"
                                style={{
                                  minHeight: "150px",
                                }}
                                defaultValue={
                                  videoToEdit && videoToEdit.transcript
                                }
                                autoComplete="off"
                                className={`${
                                  lang === 1 ? "" : "hidden"
                                } block w-full mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                                {...register("transcript", {
                                  required: false,
                                })}
                                onChange={(e) =>
                                  handleFilterChange(e, "Transcript")
                                }
                              />
                              <textarea
                                id="spanishTranscript"
                                style={{
                                  minHeight: "150px",
                                }}
                                defaultValue={
                                  videoToEdit && videoToEdit.spanishTranscript
                                }
                                autoComplete="off"
                                className={`${
                                  lang === 2 ? "" : "hidden"
                                } block w-full mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                                {...register("spanishTranscript", {
                                  required: false,
                                })}
                                onChange={(e) =>
                                  handleFilterChange(e, "SpanishTranscript")
                                }
                              />
                            </div>
                          </div>

                          <div className="flex justify-end mt-8 items-center border-t ">
                            <button
                              disabled={isSaving}
                              className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                            >
                              {idToEdit ? "Update " : "Save"}
                            </button>
                            <Link to={Constant.VIDEOS} className="ml-2">
                              <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                                Cancel
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="w-3/4">
                        {idToEdit === 0 && (
                          <Fragment>
                            <div className="flex flex-col justify-start">
                              <h2>Video</h2>
                              <div className="flex">
                                <div className="w-103 shadow-lg bg-white border mr-6 mb-6">
                                  <div className="w-103 cursor-pointer">
                                    <div
                                      className={`${
                                        lang === 1 ? "" : "hidden"
                                      } relative w-full overflow-hidden`}
                                    >
                                      {video?.videoUrl &&
                                        validateUrl(video?.videoUrl) &&
                                        !checkVideoWithPlayer(
                                          video?.videoUrl
                                        ) && (
                                          <ReactPlayer
                                            url={getVideoURL(video?.videoUrl)}
                                            className="react-player"
                                            width="100%"
                                            height="600px"
                                            controls={true}
                                            config={{
                                              file: {
                                                attributes: {
                                                  //controlsList: "nodownload",
                                                  poster: selectedThumbnail,
                                                  crossOrigin: "anonymous",
                                                },
                                                tracks: [
                                                  {
                                                    kind: "subtitles",
                                                    src:
                                                      video.englishVttUrl || "",
                                                    srcLang: "en",
                                                    label: "English",
                                                    default: true,
                                                  },
                                                ],
                                              },
                                            }}
                                          >
                                            {video.englishVttUrl && (
                                              <track
                                                label={
                                                  lang === 2
                                                    ? "Español"
                                                    : "English"
                                                }
                                                kind="subtitles"
                                                src={video.englishVttUrl}
                                                srcLang={
                                                  lang === 2 ? "es" : "en"
                                                }
                                              />
                                            )}
                                          </ReactPlayer>
                                        )}

                                      {video?.videoUrl &&
                                        validateUrl(video?.videoUrl) &&
                                        checkVideoWithPlayer(
                                          video?.videoUrl
                                        ) && (
                                          <iframe
                                            allowFullScreen
                                            className="h-40 top-0 left-0 bottom-0 right-0 w-full border-none"
                                            src={getVideoURL(video?.videoUrl)}
                                          ></iframe>
                                        )}
                                    </div>
                                    <div
                                      className={`${
                                        lang === 2 ? "" : "hidden"
                                      } relative w-full overflow-hidden`}
                                    >
                                      {video?.spanishVideoUrl &&
                                        validateUrl(video?.spanishVideoUrl) &&
                                        !checkVideoWithPlayer(
                                          video?.spanishVideoUrl
                                        ) && (
                                          <ReactPlayer
                                            url={getVideoURL(
                                              video?.spanishVideoUrl
                                            )}
                                            className="react-player"
                                            width="100%"
                                            height="600px"
                                            controls={true}
                                            config={{
                                              file: {
                                                attributes: {
                                                  //controlsList: "nodownload",
                                                  poster: selectedThumbnail,
                                                  crossOrigin: "anonymous",
                                                },
                                                tracks: [
                                                  {
                                                    kind: "subtitles",
                                                    src:
                                                      video.spanishVttUrl || "",
                                                    srcLang: "es",
                                                    label: "Español",
                                                    default: true,
                                                  },
                                                ],
                                              },
                                            }}
                                          />
                                        )}

                                      {video?.spanishVideoUrl &&
                                        validateUrl(video?.spanishVideoUrl) &&
                                        checkVideoWithPlayer(
                                          video?.spanishVideoUrl
                                        ) && (
                                          <iframe
                                            allowFullScreen
                                            className="h-40 top-0 left-0 bottom-0 right-0 w-full border-none"
                                            src={getVideoURL(
                                              video?.spanishVideoUrl
                                            )}
                                          ></iframe>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {thumbnails && thumbnails.length > 0 && (
                              <>
                                <div className="flex mt-5">
                                  <div className="text-sm flex items-center col-span-1">
                                    <label className="font-medium text-gray-700">
                                      {" "}
                                      Thumbnails
                                    </label>
                                  </div>
                                </div>
                                <div className="flex mt-3">
                                  <div
                                    id="thumbnailWrapper"
                                    className="text-sm flex items-center col-span-1 bg-gray-100 px-1 py-1 gap-4"
                                  >
                                    {thumbnails.map((thumbImage, i) => {
                                      return (
                                        <div
                                          key={i}
                                          className={`w-40 flex-none ${
                                            selectedThumbnail === thumbImage
                                              ? "cursor-pointer border-4 border-dashed border-[#1877b1] "
                                              : "cursor-pointer overflow-hidden border hover:border-4 hover:border-dashed hover:border-[#1877b1] hover:border-opacity-30 "
                                          }`}
                                        >
                                          <img
                                            key={i}
                                            src={thumbImage}
                                            className={`w-full flex-none ${
                                              selectedThumbnail === thumbImage
                                                ? "cursor-pointer "
                                                : "cursor-pointer "
                                            }`}
                                            onClick={() =>
                                              setVideoThumbnail(thumbImage)
                                            }
                                          ></img>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="flex mt-5">
                              <div className="text-sm flex items-center col-span-1">
                                <label className="font-medium text-gray-700">
                                  {" "}
                                  Transcript
                                </label>
                              </div>
                            </div>
                            <div className="flex mt-3">
                              <div className="text-sm flex items-center col-span-1 bg-gray-100 px-1 py-1">
                                <label
                                  className={`${
                                    lang === 1 ? "" : "hidden"
                                  } font-medium text-gray-700`}
                                >
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: transcriptFormater(
                                        video?.transcript
                                      ),
                                    }}
                                  />
                                </label>
                                <label
                                  className={`${
                                    lang === 2 ? "" : "hidden"
                                  }font-medium text-gray-700`}
                                >
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: transcriptFormater(
                                        video?.spanishTranscript
                                      ),
                                    }}
                                  />
                                </label>
                              </div>
                            </div>
                          </Fragment>
                        )}
                        {videoToEdit && videoToEdit.videoId > 0 && (
                          <Fragment>
                            <div className="flex items-center justify-between bg-gray-100 w-full">
                              <div className="flex">
                                <button
                                  type="button"
                                  onClick={() => setActiveTab("Video")}
                                >
                                  <h2
                                    className={
                                      activeTab === "Video"
                                        ? activeTabClass
                                        : inActiveTabClass
                                    }
                                  >
                                    Video
                                  </h2>
                                </button>
                                <button
                                  type="button"
                                  onClick={() =>
                                    setActiveTab("AssociatedQuestions")
                                  }
                                >
                                  <h2
                                    className={
                                      activeTab === "AssociatedQuestions"
                                        ? activeTabClass
                                        : inActiveTabClass
                                    }
                                  >
                                    Associated Questions
                                  </h2>
                                </button>
                                <button
                                  type="button"
                                  onClick={() => setActiveTab("videoStandards")}
                                >
                                  <h2
                                    className={
                                      activeTab === "videoStandards"
                                        ? activeTabClass
                                        : inActiveTabClass
                                    }
                                  >
                                    Video Standards
                                  </h2>
                                </button>
                                <button
                                  type="button"
                                  onClick={() => setActiveTab("Tags")}
                                >
                                  <h2
                                    className={
                                      activeTab === "Tags"
                                        ? activeTabClass
                                        : inActiveTabClass
                                    }
                                  >
                                    Tags
                                  </h2>
                                </button>
                              </div>
                            </div>
                            {activeTab === "Video" && (
                              <>
                                <div
                                  className={`${
                                    lang === 1 ? "" : "hidden"
                                  } relative w-full overflow-hidden `}
                                >
                                  {video?.videoUrl &&
                                    validateUrl(video?.videoUrl) &&
                                    !checkVideoWithPlayer(video?.videoUrl) && (
                                      <ReactPlayer
                                        url={getVideoURL(video?.videoUrl)}
                                        className="react-player"
                                        width="100%"
                                        height="600px"
                                        controls={true}
                                        config={{
                                          file: {
                                            attributes: {
                                              //controlsList: "nodownload",
                                              poster: selectedThumbnail,
                                              crossOrigin: "anonymous",
                                            },
                                            tracks: [
                                              {
                                                kind: "subtitles",
                                                src: video.englishVttUrl || "",
                                                srcLang: "en",
                                                label: "English",
                                                default: true,
                                              },
                                            ],
                                          },
                                        }}
                                      />
                                    )}

                                  {video?.videoUrl &&
                                    validateUrl(video?.videoUrl) &&
                                    checkVideoWithPlayer(video?.videoUrl) && (
                                      <iframe
                                        allowFullScreen
                                        className="h-40 top-0 left-0 bottom-0 right-0 w-full border-none"
                                        src={getVideoURL(video?.videoUrl)}
                                      ></iframe>
                                    )}
                                </div>
                                <div
                                  className={`${
                                    lang === 2 ? "" : "hidden"
                                  } relative w-full overflow-hidden `}
                                >
                                  {video?.spanishVideoUrl &&
                                    validateUrl(video?.spanishVideoUrl) &&
                                    !checkVideoWithPlayer(
                                      video?.spanishVideoUrl
                                    ) && (
                                      <ReactPlayer
                                        url={getVideoURL(
                                          video?.spanishVideoUrl
                                        )}
                                        className="react-player"
                                        width="100%"
                                        height="600px"
                                        controls={true}
                                        config={{
                                          file: {
                                            attributes: {
                                              //controlsList: "nodownload",
                                              poster: selectedThumbnail,
                                              crossOrigin: "anonymous",
                                            },
                                            tracks: [
                                              {
                                                kind: "subtitles",
                                                src: video.spanishVttUrl || "",
                                                srcLang: "es",
                                                label: "Español",
                                                default: true,
                                              },
                                            ],
                                          },
                                        }}
                                      />
                                    )}

                                  {video?.spanishVideoUrl &&
                                    validateUrl(video?.spanishVideoUrl) &&
                                    checkVideoWithPlayer(
                                      video?.spanishVideoUrl
                                    ) && (
                                      <iframe
                                        allowFullScreen
                                        className="h-40 top-0 left-0 bottom-0 right-0 w-full border-none"
                                        src={getVideoURL(
                                          video?.spanishVideoUrl
                                        )}
                                      ></iframe>
                                    )}
                                </div>
                                {thumbnails && thumbnails.length > 0 && (
                                  <>
                                    <div className="flex mt-5">
                                      <div className="text-sm flex items-center col-span-1">
                                        <label className="font-medium text-gray-700">
                                          {" "}
                                          Thumbnails
                                        </label>
                                      </div>
                                    </div>
                                    <div className="flex mt-3">
                                      <div
                                        id="thumbnailWrapper"
                                        className="text-sm flex items-center col-span-1 bg-gray-100 px-1 py-1 gap-4"
                                      >
                                        {thumbnails.map((thumbImage, i) => {
                                          return (
                                            <div
                                              key={i}
                                              className={`w-40 flex-none  ${
                                                selectedThumbnail === thumbImage
                                                  ? "cursor-pointer border-4 border-dashed border-[#1877b1] "
                                                  : "cursor-pointer overflow-hidden border hover:border-4 hover:border-dashed hover:border-[#1877b1] hover:border-opacity-30 "
                                              }`}
                                            >
                                              <img
                                                key={i}
                                                src={thumbImage}
                                                className={`w-40 flex-none ${
                                                  selectedThumbnail ===
                                                  thumbImage
                                                    ? "cursor-pointer "
                                                    : "cursor-pointer  "
                                                }`}
                                                onClick={() =>
                                                  setVideoThumbnail(thumbImage)
                                                }
                                              ></img>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </>
                                )}
                                {video.transcript && (
                                  <div className="flex mt-5">
                                    <div className="text-sm flex items-center col-span-1">
                                      <label className="font-medium text-gray-700">
                                        {" "}
                                        Transcript
                                      </label>
                                    </div>
                                  </div>
                                )}
                                <div className="flex mt-3">
                                  <div className="text-sm flex items-center col-span-1 bg-gray-100 px-1 py-1">
                                    <label
                                      className={`${
                                        lang === 1 ? "" : "hidden"
                                      } font-medium text-gray-700 `}
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: transcriptFormater(
                                            video?.transcript
                                          ),
                                        }}
                                      />
                                    </label>
                                    <label
                                      className={`${
                                        lang === 2 ? "" : "hidden"
                                      } font-medium text-gray-700 `}
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: transcriptFormater(
                                            video?.spanishTranscript
                                          ),
                                        }}
                                      />
                                    </label>
                                  </div>
                                </div>
                              </>
                            )}

                            {activeTab === "AssociatedQuestions" && (
                              <AssociatedQuestion
                                videoId={video.videoId}
                                videoData={video}
                                setAssociateQuestionIds={
                                  setAssociateQuestionIds
                                }
                                associateQuestionIds={associateQuestionIds}
                              />
                            )}

                            {activeTab === "videoStandards" && (
                              <VideoStandards videoData={video} />
                            )}

                            {activeTab === "Tags" && (
                              <TagsTab
                                handleSaveTags={handleSaveTags}
                                handleRemoveTag={handleRemoveTag}
                                selectedTagIds={selectedTagIds}
                              />
                            )}
                          </Fragment>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showLinkedStandards && linkedStandards && linkedStandards.length > 0 && (
        <LinkedStandard
          standardId={selectedStandard?.value}
          title={"Linked Standards"}
          redirectUrl={
            videoToEdit && videoToEdit.videoId
              ? Constant.VIDEOS
              : videoToEdit && videoToEdit.standardId
              ? Constant.EDITSTANDARD.replace(
                  ":id",
                  videoToEdit && videoToEdit.standardId.toString()
                )
              : Constant.VIDEOS
          }
          confirmAction={handleShowLinkedStandardsConfirmation}
          buttonText={"Ok"}
          fromPageName={constant.VIDEO}
          linkedStandardsData={linkedStandards}
        />
      )}
    </AllowedTo>
  );
}
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(ManageVideo);
